interface RuntimeConfigKeys {
  FIREBASE_API_KEY: string;
  FIREBASE_AUTH_DOMAIN: string;
  FIREBASE_PROJECT_ID: string;
  FIREBASE_STORAGE_BUCKET: string;
  FIREBASE_MESSAGING_SENDER_ID: string;
  FIREBASE_APP_ID: string;
  FIREBASE_MEASUREMENT_ID: string;
  FIREBASE_VAPID_KEY: string;
  USERSVC_API_URL: string;
  GOOGLE_MAPS_API_KEY: string;
  SOCKET_GATEWAY_URL: string;
  GA_MEASUREMENT_ID: string;
  BFM_ENABLE: string;
}

export const RuntimeConfig: Record<keyof RuntimeConfigKeys, string> =
  typeof window !== "undefined"
    ? (((window as Window & { __RUNTIME_CONFIG__?: Record<string, string> })
        .__RUNTIME_CONFIG__ ?? {}) as Record<keyof RuntimeConfigKeys, string>)
    : ({} as Record<keyof RuntimeConfigKeys, string>);
